/**
 * @param state {object} Domain state
 * @param toastMessageId {string|null} Toast message id to remove message for or null to remove all
 * @return {object} Updated domain state
 */
export const removeToastMessageReducer = (state, toastMessageId) => {

    if (toastMessageId) {
        state.toastMessages = state.toastMessages.filter(({id}) => id !== toastMessageId);
    } else {
        state.toastMessages = [];
    }

    return state;
};
